import * as React from 'react';

import { ArrowLeftOutlined as ArrowLeftIcon } from '@ant-design/icons';

import { useFormikContext } from 'formik';

import { useStepper } from '../../../context';

function BackButton() {
  const { prevStep, isFirst } = useStepper();
  const formik = useFormikContext();

  if (isFirst || formik?.status === 'submitted') return null;

  return (
    <button
      id='step-back-btn'
      className='mb-[22.8px] flex cursor-pointer items-center border-0 bg-transparent text-[10px] font-bold text-[#78909C] uppercase disabled:cursor-not-allowed disabled:opacity-70 [&:not(:disabled):hover>svg]:translate-x-[-3px]'
      onClick={prevStep}
      disabled={formik?.isSubmitting}
    >
      <ArrowLeftIcon className='mr-1.5 text-[#072D83] transition-transform duration-300' />
      Voltar
    </button>
  );
}

export { BackButton };
